import './header.scss';
import Logo from '../../assets/logo.png';
import AreasService from '../../services/areas-service';
import IndividualChallengeService from '../../services/individual-challenge-service';
import { TEAM, AREAS, SESSION, SCORE, ASSETS, CAMPAIGN_STATUS } from '../../constants';
import LocalStorage from '../../services/local-storage';
import { useState, useEffect, useRef, useCallback } from 'react';
import format from 'sugar/number/format';
import capitalize from 'sugar/string/capitalize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { Link, useNavigate } from "react-router-dom";
import TranslateService from '../../services/translate-service';
import Avatar from '../avatar/avatar';
import BannerCampaign from '../banner-campaign/banner-campaign';
import EventBusService from '../../services/EventBusService'
import { NEW_CAMPAIGN_EVENT } from '../../constants';

export default function Header() {

    const navigate = useNavigate();
    const firstUpdate = useRef(true);
    const dropdowElement = useRef(null);
    const [areas, setAreas] = useState(LocalStorage.get(AREAS) || []);
    const [team] = useState(LocalStorage.get(TEAM));
    const [score, setScore] = useState(LocalStorage.get(SCORE) || 0);
    const [session] = useState(LocalStorage.get(SESSION));

    const [dropdow, setDropdow] = useState(false);
    const [campaign, setCampaign] = useState(LocalStorage.get(CAMPAIGN_STATUS));

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            getAreas();
            getScore();

            document.addEventListener("click", (event) => {
                if (dropdowElement.current && !dropdowElement.current.contains(event.target)) {
                    setDropdow(false)
                }
            });            
            return;
        }
    });


    const handleCampaignStatus = useCallback((event) => setCampaign(event.detail?.campaign), [])

    useEffect(() => {
        EventBusService.on(NEW_CAMPAIGN_EVENT, handleCampaignStatus)

        return () => {
            EventBusService.remove(NEW_CAMPAIGN_EVENT, handleCampaignStatus)
        }
    }, [handleCampaignStatus])

    const getAreas = async () => {
        try {
            const response = await AreasService.getAreas(session._id);

            LocalStorage.set(AREAS, response);
            setAreas(response);
        } catch (error) { }
    }

    const getScore = async () => {
        try {
            const response = await IndividualChallengeService.getScore(session._id, team.area._id)

            LocalStorage.set(SCORE, response.score)
            setScore(response.score)
        } catch (error) { }
    }

    const setArea = (event) => {
        const area = areas.find(a => a.area._id === event.target.value);

        LocalStorage.set(TEAM, area)
        window.location.reload()
    }

    const logout = () => {
        LocalStorage.clear();

        navigate(`/auth/login`, { replace: true });
    }

    return (
        <>
            <div className="header">
                <div className="container mx-auto px-4">

                    <div className='flex items-center w-full py-[12px]'>
                        <div className='flex items-center '>
                            <img src={Logo} alt="" />
                            <select className="areas" onChange={setArea} value={team.area._id}>
                                {areas.map(a => <option value={a.area._id} key={a._id} >{a.area.nombre}</option>)}
                            </select>
                        </div>

                        <div className=' ml-auto relative'>
                            <div className='flex items-center ml-auto cursor-pointer dropdow' ref={dropdowElement} onClick={() => setDropdow(!dropdow)}>
                                <Avatar className='mx-auto profile' image={`${ASSETS.AVATAR_PLAYER}${session.avatar}`} />
                                <div className='text-white ml-5'>
                                    <p>{capitalize(`${session.nombre} ${session.apellidoPaterno}`, true, true)}</p>
                                    <p>{format(score)} pts</p>
                                </div>
                                <div className='ml-[8px]'>
                                    <FontAwesomeIcon icon={faCaretDown} className='text-white' />
                                </div>
                            </div>
                            <div className={'dropdow-container ' + (dropdow ? 'open' : '')}>
                                <ul>
                                    <li >
                                        <Link to='/achievements' className='heading-h6 '>{TranslateService.get('header.dropdown.achievements')}</Link>
                                    </li>
                                    <li className='py-[10px] separator-bottom'>
                                        <Link to='/settings' className='heading-h6 '>{TranslateService.get('header.dropdown.settings')}</Link>
                                    </li>
                                    <li className='heading-h6 !text-error-default cursor-pointer mt-[10px]' onClick={logout}>{TranslateService.get('header.dropdown.logout')}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            { campaign && <BannerCampaign /> }
            
        </>

    );
}
